<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <v-card>
                <!-- 搜索栏  -->
                <v-toolbar color="success">
                    <v-toolbar-title class="white--text">
                        <div style="padding-left: 20px">标记管理</div>
                    </v-toolbar-title>
                    <v-btn text icon color="white" class="ml-3 addTag" @click="addDialog = true">
                        <v-icon>add</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="px-0 py-0">
                    <v-data-table :headers="headers" :items="list" :loading="loading" loading-text="加载中..."
                        no-data-text="暂无数据" class="table" :page.sync="pagination.page" hide-default-footer
                        :items-per-page="pagination.itemsPerPage" mobile-breakpoint="0">
                        <!-- 表格头部搜索、新增 -->
                        <template #top>
                            <v-toolbar flat height="80">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="search" v-bind="attrs" v-on="on" append-icon="mdi-magnify"
                                            label="请输入名称" single-line hide-details @keydown="keydownSearch" class="queryTag"></v-text-field>
                                    </template>
                                    <span>按回车以检索</span>
                                </v-tooltip>
                            </v-toolbar>
                        </template>

                        <template #[`item.actions`]="{ item }">
                            <v-btn color="green" class="editTag" plain small @click="handleEdit(item)">
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn color="red" class="delTag" plain small @click="handleRemove(item)">
                                <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <!-- 分页 -->
                <Pagination :page.sync="pagination.page" :total="pagination.total"
                    :items-per-page.sync="pagination.itemsPerPage" @refresh="findList" />
            </v-card>
        </div>
        <v-dialog v-model="addDialog" scrollable persistent :overlay="false" max-width="500px"
            transition="dialog-transition">
            <v-card class="pa-4">
                <v-form>
                    <v-text-field name="name" label="标签名称" v-model="form.name"></v-text-field>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="handleSubmit">提交</v-btn>
                    <v-btn @click="addDialog = false">取消</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination/index";
import { listTag, addTag, updateTag, delTag } from "@/api/tag";
export default {
    name: "TagList",
    components: {
        Pagination,
    },
    computed: {},
    data() {
        return {
            headers: [
                { text: "标签名称", align: "start", value: "name", sortable: false, },
                { text: "编辑", align: "start", value: "actions", sortable: false, },
            ],
            // 搜索条件
            search: "",
            // 遮罩层
            loading: true,
            // 表格数据
            list: [],
            listTagData:[],
            // 查询参数
            queryParams: {},
            // 分页
            pagination: {
                page: 1,
                itemsPerPage: 5,
                total: 0,
            },
            // 是否显示弹出框
            showNewDialog: false,
            // 当前选中数据
            form: {},
            addDialog: false,
            updateDialog: false,
        };
    },

    created() {
        this.findList();
    },
    methods: {
        /**
         * 查询列表
         */
        findList() {
            this.loading = true
            listTag(this.queryParams).then((res) => {
                if(!this.search){
                   this.listTagData = res.data.rows
                   this.list = res.data.rows
                   this.pagination.total = res.data.total;
                   this.loading = false;
                  return 
                }
                this.list = this.listTagData.filter(item=>item.name.indexOf(this.search)!==-1)
                this.pagination.total =   this.list.total;
                this.loading = false;
            })
        },
        handleSubmit() {
            this.addDialog = false;
            const handleFunc = this.form._id ? updateTag : addTag;
            handleFunc(this.form).then(res => {
                this.findList();
                this.form = {}
            })
        },
        handleEdit(item) {
            this.form = {
                ...item
            }
            this.addDialog = true;
        },
        handleRemove(item) {
            delTag(item).then(() => this.findList())
        },
        /**
         * 搜索框点击enter事件
         */
        keydownSearch(e) {
            // 点击Enter
            if (e.keyCode === 13) {
                this.findList();
            }
        },
    },
};
</script>

  